import { ViewMode } from '../enums/view-mode';
import { type Config } from '../interfaces/config';

export const configFixture: Config = {
    user: {
        hin: undefined,
        name: undefined,
        token: undefined,
    },
    panel: {
        minimize: undefined,
        close: undefined,
        visible: false,
        viewMode: ViewMode.chooseChat,
        minimized: false,
        draggable: true,
    },
    toggle: {
        choose: {
            open: undefined,
            close: undefined,
        },
        bot: {
            open: undefined,
            close: undefined,
            switch: undefined,
        },
        live: {
            open: undefined,
            close: undefined,
            switch: undefined,
        },
    },
    bot: {
        active: false,
        targetBlank: false,
        service: {
            conversation: undefined,
            rating: undefined,
        },
        status: {
            start: undefined,
            error: undefined,
            sending: undefined,
        },
        speakMode: {
            speak: undefined,
            message: undefined,
            recording: undefined,
        },
        disclaimer: {
            title: undefined,
            text: undefined,
            button: undefined,
        },
        title: undefined,
        subtitle: undefined,
        intro: undefined,
        button: undefined,
        showUserNote: true,
        language: 'de_DE',
        rateChat: undefined,
    },
    live: {
        active: false,
        service: undefined,
        title: undefined,
        subtitle: undefined,
        intro: undefined,
        button: undefined,
    },
};
